function ValidateEmail(event) {

    var validRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    var emailRequirements = document.getElementById("emailRequirements")
    var validEmailText = document.getElementById("validEmailText");
    var emailStringInput = document.getElementById("inputEmail").value;
    emailRequirements.style.display = "block";

    if (validRegex.test(emailStringInput)) {
        validEmailText.style.color = "green";
        validEmailText.innerHTML = "✓ Email is Valid."
    } else {
        validEmailText.style.color = "red";
        validEmailText.innerHTML = "✕ Must be a valid email."
    }

    if(validEmailText.style.color==="red"){
        return false;
    }else{
        return true;
    }

  }

  export default ValidateEmail;